

import useTranslations from "../providers/useTranslations";
import { formatPrice } from "../lib/utils";

import Service from './order/service.js'

const ServiceView = (props) => {

  const { addItemToCart, optionsFirst,
    categories,
    isOffer,
    removeItem,
    setItemQuantity,
    selectedMenu,
    service,
    setSelectedService } = props;

  React.useEffect(() => {


  }, [service]);


  const titleElement = () => {

    let fsize = Math.max(10, Math.min(40, 40 - (service.name.length - 4)))

    //console.log("ServiceView titleElement service name", service.name, service.name.length, fsize)

    return (
      <div className="titleElement mt-3 py-2 col-md-12">

        <span className="category-expander" onClick={() => setSelectedService(null)} style={{
          marginRight: 5, fontSize: fsize
        }}>
          <i className="fa fa-chevron-left fa-2x" aria-hidden="true" style={{ color: '#222' }}></i>
        </span>

        <span style={{
          fontSize: fsize
        }}>
          {service.name} <br />

        </span>

      </div>
    )
  }


  //console.log("category", category.name, category.Categories, category.Products)

  return (<div id={`service_${service.name}`} className="ServiceView row px-1" >

    {titleElement()}


    <div className="col-md-12" style={{
      padding: 4
    }}>

      <div id={`service_content_${service.id}`}
        className="service-content mb-1">


        <ServiceDetails
          categories={categories}
          service={service}
          hasOrdering={true}
          priceUnit='$'
          isOffer={isOffer}
          getValue={(args) => {
            console.log("getValue add to cart", service.id, args);
            if (args.quantity === 1) {
              // make a copy of the object
              let newItem = Object.assign({}, service);
              newItem.quantity = 1
              newItem.menu_id = service.menu_id || selectedMenu.id
              addItemToCart(newItem, args);
            } else if (args.quantity === 0) {
              removeItem(service, args);
            } else {
              setItemQuantity(service, args.quantity);
            }

          }}
          onClose={() => {
            setSelectedService(null)
          }}
          detailColour={'#F1AD3E'}
          optionsFirst={optionsFirst}
        />

      </div>

    </div>

  </div>)
}

export default ServiceView

function ServiceDetails(props) {
  const { service, hasOrdering, onClose, isOffer, categories, detailColour, optionsFirst } = props

  const [displayPrice, setDisplayPrice] = React.useState(service.price)
  const [numItems, setNumItems] = React.useState(1)

  const { tr } = useTranslations();

  const IncrementItem = () => {
    setNumItems(numItems + 1);
  }
  const DecreaseItem = () => {
    if (numItems > 1) {
      setNumItems(numItems - 1);
    }
  }

  const getDisplayedBasePrice = () => {
    // if this is a combo service and the price is 0 then display a message
    if (isOffer) {
      return tr("Only available in the XooNoo mobile app")
    }
    if (displayPrice == 0) {
      return tr("Price may vary")
    }
    return formatPrice(displayPrice)
  }

  const formatDuration = (minutes) => {
    if (!minutes) return "";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours > 0) {
      return `${hours}h ${mins > 0 ? mins + 'm' : ''}`;
    }
    return `${mins}m`;
  }

  const _totalPrice = () => {
    if (displayPrice == 0) {
      return <></>
    }
    return <span>Total: <b>{formatPrice(numItems * displayPrice)}</b></span>

  }

  const totalHeader = () => {
    return <div className="ServiceView-total-header" style={{ padding: 0, minWidth: "145px" }}>
      <div className="my-1 service-displayed-base-price">@ {getDisplayedBasePrice()}</div>
      {service.duration && (
        <div className="service-duration text-gray" style={{ fontSize: "14px" }}>
          Duration: {formatDuration(service.duration)}
        </div>
      )}
      <div className="justify-content-center" style={{ marginLeft: -5, marginTop: "5px", marginBottom: "5px", minWidth: "120px" }}>
        <span className="" style={{}}>
          <button variant="" onClick={DecreaseItem} className="btn-count"> <i className="icofont-minus" /> </button>
          <input className="count-number-input count-number" type="text" value={numItems} readOnly />
          <button variant="" onClick={IncrementItem} className="btn-count"> <i className="icofont icofont-plus" /> </button>
        </span>
        <span className=" service-total" style={{ padding: 0, paddingTop: "6px", fontSize: "15px" }}>
          {_totalPrice()}
        </span>
      </div>
    </div>
  }

  const assetHeader = (url) => {
    return <div className='row service-header asset-service-header centered' >
      <img onClick={onClose}
        src={url} alt={props.imageAlt}
        style={{
          borderRadius: "8px", marginRight: "5px", padding: 0, marginBottom: "5px",
          maxHeight: 200,
          minHeight: 200,
          minWidth: 330,
          maxWidth: 600,
        }}
      />
      {totalHeader()}

    </div>
  }

  const imageHeader = (image) => {
    return <div>

      <div className=' service-header image-service-header centered' >
        {image ?
          <div onClick={() => {
            onClose()
          }}>

            <img className={props.imageClass} src={image} alt={props.imageAlt}
              style={{ borderRadius: 5, width: "60%" }} />
          </div>
          :
          <div onClick={() => {
            onClose()
          }} className="mr-3"><i className={"icofont-ui-press text-" + props.badgeVariant + " service-item"} /></div>
        }


      </div>
      <div>

        {totalHeader()}
      </div>
    </div>

  }

  const serviceHeader = () => {
    // Check if service has assets similar to products
    if (service.Assets != null && service.Assets.length > 0) {
      return assetHeader(service.Assets[0].url)
    }

    let image = service.photo
    if (image == null || image == "") {
      image = business.photo
    }

    return imageHeader(image)
  }

  return (
    <div className={"p-4 QuickBite " + props.itemClass}>


      <div>
        {serviceHeader()}

        <Service service={service}
          categories={categories}
          value={numItems}
          isOffer={isOffer}
          onClose={onClose}
          detailColour={detailColour}
          setDisplayTotal={(price, serv) => {
            setDisplayPrice(price)
          }}
          formatPrice={formatPrice}
          getDisplayedBasePrice={getDisplayedBasePrice}
          increment={IncrementItem}
          decrement={DecreaseItem}
          hasOrdering={hasOrdering} optionsFirst={optionsFirst} />

      </div>

    </div>
  );
}
